export { MarketingBanner } from './MarketingBanner';
